import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { versesService } from '../../services/versesService'
import { useTheme } from '../../contexts/ThemeContext'
import { storage } from '../../utils/storage'
import { logError } from '../../utils/logError'
import { UA_REF_MAP } from './bibleBooks'

function parseVerseRef(reference) {
  if (!reference) return null
  const norm = reference.toLowerCase().replace(/\./g, '').replace(/\s+/g, '')
  let bestAbbr = null, bestId = null
  for (const [abbr, id] of Object.entries(UA_REF_MAP)) {
    if (norm.startsWith(abbr) && (!bestAbbr || abbr.length > bestAbbr.length)) {
      bestAbbr = abbr; bestId = id
    }
  }
  if (!bestId) return null
  const rest = norm.slice(bestAbbr.length).replace(/^[.:\s]+/, '')
  const chM = rest.match(/^(\d+)/)
  if (!chM) return null
  const chapter = parseInt(chM[1], 10)
  const afterCh = rest.slice(chM[0].length).replace(/^[:]+/, '')
  const verseM = afterCh.match(/^(\d+)/)
  return { bookId: bestId, chapter, verse: verseM ? parseInt(verseM[1], 10) : null }
}

export const BibleOfTheDay = () => {
  const [verse, setVerse] = useState(null)
  const [visible, setVisible] = useState(false)
  const lang = storage.language.get()
  const { isDark } = useTheme()

  useEffect(() => {
    versesService.getVersesOnce().then(list => {
      if (list.length) setVerse(list[Math.floor(Math.random() * list.length)])
    }).catch(err => logError(err, 'verse of the day'))
  }, [])

  useEffect(() => {
    if (!verse) return
    const t = setTimeout(() => setVisible(true), 60)
    return () => clearTimeout(t)
  }, [verse])

  if (!verse) return null

  const text   = lang === 'en' ? (verse.textEn || verse.text) : verse.text
  const ref    = lang === 'en' ? (verse.referenceEn || verse.reference) : verse.reference
  const parsed = parseVerseRef(verse.reference)

  const s = styles(isDark)

  return (
    <div style={{ ...s.wrap, opacity: visible ? 1 : 0 }}>
      <div style={s.mark}>"</div>
      <p style={s.text}>{text}</p>
      <div style={s.ref}>
        {parsed ? (
          <Link
            to='/bible'
            style={s.refLink}
            onClick={() => storage.bibleLastPos.set(parsed)}
          >
            — {ref}
          </Link>
        ) : `— ${ref}`}
      </div>
    </div>
  )
}

const styles = (isDark) => ({
  wrap: {
    width: '100%',
    boxSizing: 'border-box',
    background: isDark ? '#3a3020' : '#f5ede3',
    borderRadius: '12px',
    padding: '32px 32px 28px',
    textAlign: 'center',
    boxShadow: '0 6px 20px rgba(92, 61, 46, 0.18)',
    transition: 'opacity 3s ease, background 0.3s',
  },
  mark: {
    fontSize: '56px',
    lineHeight: '0.5',
    color: '#c4986a',
    marginBottom: '14px',
    fontFamily: 'Georgia, serif',
    userSelect: 'none',
    textShadow: '0 2px 4px rgba(139, 96, 68, 0.25)',
  },
  text: {
    fontSize: '20px',
    lineHeight: '1.75',
    color: isDark ? '#f0ead8' : '#2d1f14',
    fontStyle: 'italic',
    fontFamily: 'Georgia, "Times New Roman", serif',
    margin: '0 auto 16px',
    maxWidth: '680px',
    letterSpacing: '0.15px',
    transition: 'color 0.3s',
  },
  ref: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#c4986a',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
  },
  refLink: {
    color: '#c4986a',
    textDecoration: 'underline',
    textDecorationStyle: 'dashed',
    textUnderlineOffset: '3px',
    textDecorationColor: 'rgba(196,152,106,0.5)',
  },
})
